export enum AttentiveIntegrationPurpose {
  Support = "support",
  Marketing = "marketing",
  Recover = "recover",
  Returns = "returns",
}
